
































































































import type { User } from '@/models/user';
import { Component, Vue } from 'vue-property-decorator';
import { userWebservice } from '@/webservices/user';
@Component({
    name: 'ForgotPassword',
})
export default class ForgotPassword extends Vue {
    // Data
    private user: User = {} as User;
    private disabled: boolean = false;
    private errorMsg: string = '';
    private serverErrorMsg: string = '';
    private emailSent: boolean = false;

    // Methods
    private sendEmail() {
        const self = this;
        self.errorMsg = '';
        self.serverErrorMsg = '';

        if (!this.validateEmail(this.user.email)) {
            this.errorMsg = 'email';
            return 0;
        }
        self.disabled = true;

        userWebservice
            .forgotPassword(this.user)
            .then(function (response) {
                self.errorMsg = '';
                self.emailSent = true;
            })
            .catch(function (error) {
                self.serverErrorMsg = self.$t('messages.AnErrorHasOccurredPleaseTryAgain').toString();
                self.disabled = false;
                console.log(error);
            });
    }

    private validateEmail(email: string) {
        /* tslint:disable-next-line:max-line-length */
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email.toLowerCase());
    }
}
